import groupManagementService from '../services/groupManagementService';

export const fetchAllGroups = async () => {
  const result = await groupManagementService.getAllGroups();
  if (!result?.success) {
    const error = new Error(result?.message || 'Gruplar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchGroupById = async (id) => {
  const result = await groupManagementService.getGroupById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Grup alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateGroup = async (payload) => {
  const result = await groupManagementService.updateGroup(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Grup güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createGroup = async (payload) => {
  const result = await groupManagementService.createGroup(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Grup oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteGroup = async (id) => {
  const result = await groupManagementService.deleteGroup(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Grup silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const addMemberToGroup = async (payload) => {
  const result = await groupManagementService.addMemberToGroup(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeMemberFromGroup = async (payload) => {
  const result = await groupManagementService.removeMemberFromGroup(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye kaldırılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const searchGroups = async ({ keyword }) => {
  const result = await groupManagementService.searchGroups({ keyword });
  if (!result?.success) {
    const error = new Error(result?.message || 'Gruplar aranamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const setGroupLeader = async ({ groupId, memberId }) => {
  const result = await groupManagementService.setGroupLeader({ groupId, memberId });
  if (!result?.success) {
    const error = new Error(result?.message || 'Grup lideri belirlenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllGroups,
  fetchGroupById,
  updateGroup,
  createGroup,
  deleteGroup,
  addMemberToGroup,
  removeMemberFromGroup,
  searchGroups,
  setGroupLeader,
};


